import { Fragment } from "react";

import Datepicker from "../components/datepicker/datepicker";
import EnumerationField from "../components/enumeration-field/enumeration-field";
import { ITableRowData } from "../components/normal-table/normal-table";
import SearchInput from "../components/search-input/search-input";
import TextArea from "../components/text-area/text-area";
import TextInput from "../components/text-input/text-input";
import { IFieldConfigDefinition } from "../definitions/field";

export interface IProps {
  fields: IFieldConfigDefinition[];
  data: ITableRowData;
  mode?: string;
  extraId?: string;
  handleOnChange(targetVal: string, inputKey: string, id: string, extraId?: string, parentID?: string): void;
  deleteInput?: (id: string) => void;
  getData?: (url: string) => void;
}

export const RenderFields = ({ fields, data, extraId, mode, deleteInput, getData, handleOnChange }: IProps) => {
  const result: (JSX.Element | undefined)[] = fields.map(
    (field) => {
      switch (field.dataType.type) {
        case "noDisplayCol":
          return undefined;
        case "textarea":
          return <TextArea
            key={field.key}
            id={data.id? data.id : field.key}
            mode={mode === "aside" ? "aside" : ""}
            label={field.noLabel ? "" : (field.displayName || "")}
            required={field.required === false? field.required : true}
            inputKey={field.key}
            defaultValue={data[field.key] === undefined? "" : data[field.key]}
            handleOnChange={handleOnChange}
            placeholder={field.placeholder && field.placeholder}
            disabled={field.disabled}
            extraClass={field.extraClass}
            generateUniqueId={field.generateUniqueId}
            extraId={extraId}
            size={field.dataType.size || "small"}
          />;
        case "text":
          return <TextInput
            key={field.key}
            name={field.key}
            subType={field.subType}
            type={field.dataType.type}
            errorMsg={field?.errorMsg}
            id={data.id? data.id : field.key}
            mode={mode === "aside" ? "aside" : ""}
            label={field.noLabel ? "" : (field.displayName || "")}
            required={field.required === false? field.required : true}
            inputKey={field.key}
            defaultValue={data[field.key] === undefined? "" : data[field.key]}
            value={data[field.key] === undefined? "" : data[field.key]}
            handleOnChange={handleOnChange}
            placeholder={field.placeholder && field.placeholder}
            disabled={field.disabled}
            inputTypeLimit={field.inputTypeLimit}
            onlyWholeNumbers={field.onlyWholeNumbers}
            deleteInput={deleteInput}
            controlled={!!field.controlled}
            extraClass={field.extraClass}
            generateUniqueId={field.generateUniqueId}
            extraId={extraId}
            extraToolTipInfo={field.extraToolTipInfo}
            decimalsFormatting={field?.decimalsFormatting}
          />;
        case "enumeration":
          return (
            <EnumerationField
              key={field.key}
              id={data.id? data.id : field.key}
              noEmptyDefault={field.noEmptyDefault}
              data={field.dataType.values}
              type={data?.field_datatype}
              inputKey={field.key}
              mode={mode === "aside" ? "aside" : ""}
              label={field.noLabel ? "" : (field.displayName || "")}
              handleOnChange={handleOnChange}
              defaultValue={data[field.key] === undefined ? "" : data[field.key]}
              required={field.required === false? field.required : true}
              autoFocus={false}
              disabled={field.disabled}
              extraClass={field.extraClass}
              generateUniqueId={field.generateUniqueId}
              extraId={extraId}
            />
          );
        case "dateTime":
          return (
            <Datepicker
              data={data[field.key] === undefined? "" : data[field.key]}
              label={`Select ${field.displayName}`}
              mode={mode === "aside" ? "aside" : ""}
              handleOnChange={handleOnChange}
              key={field.key}
              valueType={field.valueType}
            />
          );
        case "reference": {
          let defineId = "";
          if (field.smart) {
            if (data.referencing_component_id && field.key === "referencing_component") {
              defineId = "referencing_component";
            } else if (data.referencing_component_id && field.key === "referencing_component_field") {
              defineId = data.referencing_component_id;
            } else {
              defineId = field.key;
            }
          } else if (field.key === "license_name" || field.key === "tmsconfig_name" || field.key === "selected_template_layout_name") {
            defineId = field.key;
          } else {
            defineId = data.id || field.key;
          }
          
          return (
            <SearchInput
              id = {defineId}
              parentId={data.id}
              autocompleteOff= {field.autocompleteOff}
              data={field.dataType.values}
              dataType={field.dataType.type}
              getData={getData}
              mode={mode === "aside" ? "aside" : ""}
              key={field.key}
              inputKey={field.key}
              placeholder={field.placeholder && field.placeholder}
              handleOnChange={handleOnChange}
              defaultValue={data[field.key] === undefined? "" : data[field.key]}
              required={field.required === false? field.required : true}
              label={field.noLabel ? "" : (field.displayName || "")}
              disabled={field.disabled}
              extraId={extraId}
              generateUniqueId={field.generateUniqueId}
              extraClass={field.extraClass}
              onFocusEmpty={field.onFocusEmpty}
              extraToolTipInfo={field.extraToolTipInfo}
            />
          );
        }
        default:
          return undefined;
      }
    }
  );
  return <Fragment>{result}</Fragment>;
};
